import BaseModel from "./base/baseModel";
import { TipoVendaClienteModel } from "./tipoVendaClienteModel";

export default class TipoVendaModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    descricao: string = "";
    utilizaValorCusto = false;
    emiteNFe = true;
    emiteNFSe = true;
    pontuaProgramaFidelidade = false;
    permiteControlados = true;
    tipoVendaGrupoAtlas = false;
    permiteNFeSemFaturamento = false;
    permiteNFSeSemFaturamento = false;
    permiteNFCeSemFaturamento = false;
    movimentaEstoque = true;
    tiposClientesPermitidos: Array<TipoVendaClienteModel> = [];
    naturezaOperacaoDentroEstadoId?: number | null = null;
    naturezaOperacaoForaEstadoId?: number | null = null;
    naturezaOperacaoDentroEstadoFracionamentoId?: number | null = null;
    naturezaOperacaoForaEstadoFracionamentoId?: number | null = null;
}
